import commonEn from './en/common_en' //公用
import loginEn from './en/login_en' //登录
import dataScreenEn from './en/dataScreen_en' //大屏
import multiStationEn from './en/multiStation_en' //多站总览

import deviceMonitorEn from './en/deviceMonitor_en' //设备监控
import elecPriceEn from './en/elecPrice_en' //电价管理
import poStaManageEn from './en/powerStaManage_en' //电站管理
import repPowerEn from './en/repPower_en' //电量报表
import faultWarningEn from './en/faultWarning_en' //站点告警

import repProfitEn from './en/repProfit_en' //收益报表
import stationCardEn from './en/sationCard_en' //站点卡片
import stationOverviewEn from './en/stationOverview_en' //单站概览
import stationSystemEn from './en/stationSystem_en' //站点系统

import alarmMonitorEn from './en/alarmMonitor_en' //告警监控

import stenManageEn from './en/stencilManage_en' //公共模版
import sysManageEn from './en/sysManage_en' //系统管理
import userManageEn from './en/userManage_en' //用户管理
import workOrderEn from './en/workOrder_en' //工单管理
export default {
  ...commonEn,
  ...loginEn,
  ...dataScreenEn,
  ...multiStationEn,
  ...deviceMonitorEn,
  ...elecPriceEn,
  ...faultWarningEn,
  ...poStaManageEn,
  ...repPowerEn,
  ...repProfitEn,
  ...stationCardEn,
  ...stationOverviewEn,
  ...stationSystemEn,
  ...alarmMonitorEn,
  ...stenManageEn,
  ...sysManageEn,
  ...userManageEn,
  ...workOrderEn,
  工商业储能云平台: 'EMS Cloud Platform',
  智慧储能云平台: 'EMS Cloud Platform',
  STE智慧储能云: 'Santie Intelligent Energy Storage Cloud Platform',
  '赛唯E宝 工商业储能云平台': 'SAV Energy Storage Cloud Platform',
  '驰硕-智慧储能云平台': 'ChiShuo-EMS Cloud Platform',
  '云基慧-智慧储能云平台': 'Ujoinwe-Intelligent Energy Storage Cloud Platform',
  鹏洲储能云平台: 'Pengzhou Energy Storage Cloud Platform',
  智慧储能管控平台: 'Intelligent energy storage cloud platform',
  客户名称: 'Customer name',
  数据大屏: 'Data screen',
  多站总览: 'Multi site Overview',
  单站数据: 'Single station data',
  电站概览: 'Overview of the power plant',
  站点系统: 'Site System',
  设备监控: 'Equipment monitoring',
  故障告警: 'Fault Alarm',
  电价管理: 'Electricity price management',
  统计报表: 'Statistical report',
  电量报表: 'Electricity report',
  收益报表: 'Income statement',
  系统管理: 'System management',
  电站管理: 'Power station management',
  公共模版: 'Public template',
  账号管理: 'Account management',
  运维管理: 'Operation and maintenance management',
  工单管理: 'Work order management',
  收起: 'Retract',

  退出登录: 'Logout',
  修改密码: 'Change password',
  原密码: 'Old password',
  确认新密码: 'Confirm new password',
  请输入原密码: 'Please enter the old password',
  请输入新密码: 'Please enter your new password',
  '密码更改成功，请重新登录': 'Password changed successfully, please log in again!',

  查询: 'Query',
  重置: 'Reset',
  导出: 'Export',
  序号: 'Serial Number',
  创建电站: 'Create a power station',

  站点总数: 'Total number of sites',
  在线: 'Online',
  离线: 'Offline',
  个: '',
  装机功率: 'Installed power',
  装机容量: 'Installed capacity',
  今日充电量: 'Charging data/Today',
  月充电: 'Monthly',
  累计充电: 'Accumulated',
  今日放电量: 'Discharge data/Today',
  月放电: 'Monthly',
  累计放电: 'Accumulated',
  今日收益: 'Income for the day',
  本月收益: 'Monthly income',
  总收益: 'Total revenue',
  '当日/元': 'Today',
  '当月/万元': 'Monthly/K',

  今日告警: 'Today＇s alarm',
  已结束: 'Ended',
  发生中: ' In progress',
  条: ' ',

  较昨日增长: 'Compared to yesterday',
  较昨日下降: 'Compared to yesterday',

  关闭: 'Close',

  收益统计: 'Revenue statistics',
  充放电统计: 'Electricity statistics',
  收益排名: 'Revenue ranking',
  近7日: 'Last 7 days',
  近31日: 'Last 31 days',
  近12月: 'Last 12 months',
  三十日内: 'Last 30 days',
  一年内: 'Latest year',
  本周: 'This week',
  本月: 'This month',
  本年: 'This year',
  收益万元: 'Income/K',
  单位: 'Unit',
  收益: 'Income',
  充电: 'Charging',
  放电: 'Discharging',

  站点列表: 'Site List',
  通讯状态: 'Communication Status',
  全部: 'All',
  电站筛选: 'Power station screening',
  待运维电站: 'Power station to be operated and maintained',
  电站名称: 'Name of power station',
  电站状态: 'Station status',
  在线状态: 'Online status',
  // 今日充电量: '今日充电量',
  // 今日放电量: '今日放电量',
  总充电量: 'Total charging capacity',
  总放电量: 'Total discharge capacity',
  '昨日收益(元)': 'Yesterday＇s earnings(CNY)',
  '总收益(万元)': 'Total revenue（K）',
  综合效率: 'Overall efficiency',
  '指单位时间内的电站放电量 ÷ 充电量': 'refer to the power station discharge ÷ charging amount per unit time.',

  放电达成率: 'Discharge completion rate',

  '指单位时间内的电站放电量 ÷（装机容量 × 放电天数），放电天数指实际放电大于 0 的天数':
    'Discharge completion rate: refer to the discharge capacity of the power station per unit time ÷ (installed capacity ×  Discharge days ). Discharge days: refer to the number of days when the actual discharge is greater than 0.',

  电网有功功率: 'Active power of the power grid',
  储能有功功率: 'Energy storage active power',
  负载有功功率: 'Load active power',

  站点信息: 'Site information',
  电站类型: 'Type of power station',
  装机总容量: 'Total installed capacity',
  投运时间: 'Operation time',
  电站地址: 'Address',
  查看详细: 'Details',
  效率: 'Efficiency',
  暂无站点图片: 'No site pictures',
  查看电站: 'View power station',
  // 工商业: '工商业',
  // 户用: '户用',

  远程控制: 'Remote control',
  能量管理: 'Energy management',
  禁止放电: 'Prohibit discharge',
  能量控制: 'Energy control',
  防过载: 'Anti overload',
  防逆流: 'Anti-reflux',
  防逆流时段: 'Anti-reflux time frame',
  余量功率: 'Residual power',
  防过载功能: 'Anti overload function',
  防逆流功能: 'Anti reflux function',
  '请确认是否启用防过载功能？': 'Please confirm if the anti overload function is enabled?',
  '请确认是否禁用防过载功能？': 'Please confirm if the anti overload function is disabled?',
  '请确认是否启用防逆流功能？': 'Please confirm if the anti reflux function is enabled?',
  '请确认是否禁用防逆流功能？': 'Please confirm if the anti reflux function is disabled?',

  能量控制策略应用月份需满足12个月点击页面底部应用按钮下发后方可执行:
    'The application month of the energy control strategy needs to be 12 months. It can only be executed after clicking the "Apply" button at the bottom of the page and issuing it.',
  新建策略: 'New policy',
  应用月份: 'Application Month',
  操作人: 'Operator',
  请确认是否删除该策略: 'Please confirm whether to delete the policy?',
  引用: 'Cite',
  应用月份未满12个月请新建策略: 'The application month is less than 12 months, please create a new policy!',
  已满12个月可点击应用按钮下发执行: 'It has been 12 months and can be executed by clicking the "Apply" button!',
  最大充电功率: 'Maximum charging power',
  最大放电功率: 'Maximum discharge power',
  编辑策略: 'Edit Policy',
  应用月份选择: 'Application Month Selection',
  月份支持一次选择多个选择完成后在下方填写所选月份的能量控制参数: 'Multiple months can be selected at once. After selection, fill in the energy control parameters for the selected month below.',
  月份: 'Month',
  能量控制参数: 'Energy control parameters',
  为选择的月份设置参数后需点击确定按钮: 'After setting parameters for the selected month, click the "OK" button.',
  对应时段: 'Corresponding time period',
  请选择配置月份: 'Please select the configuration month!',
  请配置能量控制参数: 'Please configure energy control parameters!',
  请选择时间: 'Please select a time!',
  请输入最大放电功率: 'Please enter the maximum discharge power!',
  请输入最大充电功率: 'Please enter the maximum charging power!',
  '最大充电功率数值范围0-9999整数': 'Maximum charging power Value range 0 to 9999 integer',
  '最大放电功率数值范围0-9999整数': 'Maximum discharge power Value range 0 to 9999 integer',

  已满12个月无法引用: 'It has been 12 months and cannot be used.',
  已满12个月无法新建策略: 'It has been 12 months and cannot be used.',
  该月份在其他策略中已选择: 'This month has been selected in other strategies.',
  查看详情: 'Detail',
  '1月': 'January',
  '2月': 'February',
  '3月': 'March',
  '4月': 'April',
  '5月': 'May',
  '6月': 'June',
  '7月': 'July',
  '8月': 'August',
  '9月': 'September',
  '10月': 'October',
  '11月': 'November',
  '12月': 'December',
  一月: '1',
  二月: '2',
  三月: '3',
  四月: '4',
  五月: '5',
  六月: '6',
  七月: '7',
  八月: '8',
  九月: '9',
  十月: '10',
  十一月: '11',
  十二月: '12',
  月1: '',
  刷新: 'refresh',

  数值范围: 'Numeric range',
  余量功率设置时请将参数控制在变压器容量的百分之五至百分之二十之间: 'When setting the residual power, please control the parameters between 5% and 20% of the transformer capacity.',
  请确认是否应用余量功率参数: 'Please confirm whether to apply the margin power parameter!',
  请确认是否应用能量控制参数: 'Please confirm whether to apply energy control parameters!',
  请确认是否应用防过载参数: 'Please confirm if the anti overload parameter is applied!',
  请确认是否应用防逆流参数: 'Please confirm whether to apply anti backflow parameters!',

  设置参数后需点击应用按钮方可执行无充电或放电操作的时间段将执行待机操作:
    'After setting the parameters, you need to click the "Apply" button to execute. During the time period without charging or discharging operation, standby operation will be executed!',
  设置参数时请按照禁充阈值大于限充阈值大于启动阈值填写: 'When setting parameters, please fill in according to "Prohibit Charging Threshold>Limit Charging Threshold>Start Threshold"! ',
  请按照禁充阈值大于限充阈值大于启动阈值填写: 'Please fill in according to "Prohibit Charging Threshold>Limit Charging Threshold>Start Threshold"! ',
  设置参数时请按照启动阈值大于限放阈值大于禁放阈值填写: 'When setting parameters, please fill in according to "Start threshold>Limit threshold>Prohibit threshold"!',
  请按照启动阈值大于限放阈值大于禁放阈值填写: 'Please fill in according to "Start threshold>Limit threshold>Prohibit threshold"!',
  执行储能控制类别: 'Execute energy storage control category',
  计划功率: 'Planned power',
  请输入功率: 'Please input power',
  跟随能量控制自动配置: 'Follow the energy control automatic configuration',
  应用: 'Application',
  防过载设置: 'Anti overload setting',
  防过载控制: 'Anti overload control',
  限充阈值: 'Charge limit threshold',
  限放阈值: ' Limiting discharge threshold ',
  请输入: 'Please enter',
  启动阈值: 'Start threshold',
  禁充阈值: 'Forbidden charging threshold',
  禁放阈值: ' Prohibit discharge threshold ',
  调节量: 'Adjustment amount',
  防逆流设置: ' Anti backflow setting ',
  防逆流控制: 'Anti backflow control',
  请输入计划功率: 'Please enter the planned power',
  '计划功率数值范围0-9999整数': 'Planned power Value range 0 to 9999 integer',
  请选择类别: 'Please select a category',
  请输入限充阈值: 'Please enter the charge limit threshold',
  请输入启动阈值: 'Please enter a start threshold',
  请输入禁充阈值: 'Please enter the prohibited charging threshold',
  请输入调节量: 'Please enter the adjustment amount',
  请输入限放阈值: 'Please enter the limit discharge threshold ',
  请输入禁放阈值: 'Please enter the threshold for prohibiting discharge ',

  余量功率设置: 'Margin power setting',
  变压器容量: 'Transformer capacity',
  充电余量: 'Charging margin',
  放电余量: 'Discharge margin',
  EMS使能: 'EMS Enable',
  使能: 'Enable',
  禁能: 'Forbidden energy',
  请输入变压器容量: 'Please enter the transformer capacity',
  请输入充电余量: 'Please enter the charging allowance',
  请输入放电余量: 'Please input the discharge margin',

  是否放弃修改: 'Do you want to abandon the modification?',
  当前页面参数已调整请确认是否要放弃修改: 'The current page parameters have been adjusted. Are you sure you want to discard the modifications? ',
  时段设置冲突: ' Time period setting conflict ',
  时间段设置不可重叠请重新调整: 'The time period settings cannot overlap, please adjust again!',
  好的: 'OK',
  放弃: 'Discard changes',

  手动控制: 'Manual',
  并网控制: 'Grid-connected control',
  PCS控制: 'PCS control',
  控制设置: 'Control settings',
  当前状态: 'Current state',
  控制类别: 'Control category',
  控制参数: 'Control parameters',
  跟随能量控制: 'Follow energy control',
  调整控制模式: 'Adjusting the control mode',
  '下发“并网/离网”指令后，请“开启/断开”市电网电路！': 'After issuing the "grid connection/disconnection" command, please "turn on/off" the municipal power grid circuit!',
  并网运行: 'Grid connected operation',
  离网运行: 'Off grid operation',
  '请确认是否下发PCS运行/停机指令！': 'Please confirm whether to issue PCS operation/shutdown instructions!',
  PCS运行: 'PCS operation',
  PCS停机: 'PCS shutdown',
  请确认是否应用: 'Please confirm whether to apply?',

  二级保护: 'Secondary protection',
  二级保护设置: 'Secondary protection settings',
  当前参数: 'Current parameters',
  SOC上限: 'SOC upper limit',
  SOC下限: 'SOC Lower limit',
  SOC充电上限: 'SOC charging upper limit',
  SOC放电下限: 'SOC discharge Lower limit',
  放电截止电压: 'Discharge Cut-off Voltage',
  充电截止电压: 'Charging cutoff voltage',
  过放释放电压: 'Overdischarge release voltage',
  过充释放电压: 'Overcharge release voltage',
  二级保护参数设置: 'Secondary protection parameter settings',
  请输入SOC上限: 'Please enter the SOC upper limit',
  请输入SOC下限: 'Please enter the SOC Lower limit',
  请输入SOC充电上限: 'Please enter the SOC charging upper limit',
  请输入SOC放电下限: 'Please enter the SOC discharge Lower limit',
  请输入放电截止电压: 'Please input the discharge cut-off voltage',
  请输入充电截止电压: 'Please input the charging cut-off voltage',
  请输入过放释放电压: 'Please input the overvoltage release voltage',
  请输入过充释放电压: 'Please input overcharge release voltage',
  '请确认是否应用二级保护参数？': 'Please confirm if secondary protection parameters are applied?',

  当前站点系统: 'The current site system is ',
  已离线: 'offline',
  最后数据时间: 'Last data time',
  系统列表: 'System list',
  请输入内容: 'Please enter content',
  系统编号: 'System number',
  总有功功率: 'Total active power',
  负载功率: 'Load power',
  今日充放电量: 'Charging/discharging capacity today',
  总充放电量: 'Total charge/discharge capacity',
  累计充放电量: 'Accumulated charging/discharging capacity',
  负载用电量: 'Load consumption',
  实时数据: 'Real time data',
  电池堆: 'Battery stack ',
  告警状态: 'Alarm status',
  进入设备监控: 'Enter device monitoring',
  名称: 'Name',
  状态: 'State',
  运行状态: 'Running state',
  光伏: 'Photovoltaic',
  电网: 'Power grid',
  负载: 'Load',
  储能: 'Energy storage',
  功率趋势: 'Power trend ',
  最大充电功率: 'Maximum charging power ',
  最大放电功率: 'Maximum discharge power ',
  最大负载功率: 'Maximum load power ',
  功率: 'Power',
  实时运行: 'Real time operation',
  数据类型: 'Data type',
  运行曲线: 'Operation curve',
  '请选择设备和字段！': 'Please select device and field!',
  实时: 'Real time',
  实时电量收益: 'Real time electricity revenue ',
  请选择站点系统时间: 'Please select a site, system, and time! ',
  日期: 'Date',
  时间: 'Time',
  充电量: 'Charge capacity',
  放电量: 'Discharge capacity',
  当前收益元: 'Current income(CNY)',
  尖: 'Tip',
  峰: 'Peak',
  平: 'Flat',
  谷: 'Valley',
  总: 'Total',
  禁放阀值小于限放阀值小于启动阀值: 'Prohibit threshold < Limit threshold < Start threshold',
  启动阀值小于限放阀值小于禁放阀值: 'Start threshold < Limit threshold < Prohibit threshold',

  数据时间: 'Data time',
  数据导出: 'Data export',
  电表: 'Meter',
  空调: 'Air-conditioning',
  箱变: 'Box-type transformer',
  工作状态: 'Working condition',
  运行: 'Operation',
  故障: 'Malfunction',
  停机: 'Shutdown',
  并网状态: 'Grid connection status',
  // 并网: 'Grid connection',
  // 离网: 'Off-grid',
  设备状态: 'Equipment status',
  正常: 'Normal',
  控制模式: 'Control model',
  手动: 'Manual operation',
  远程: 'Remote',
  当日充电量: 'Daily charging capacity',
  当日放电量: 'Daily discharge capacity',
  交流频率: 'AC frequency',
  总交流有功功率: 'Total AC active power',
  总交流无功功率: 'Total AC reactive power',
  总交流视在功率: 'Total AC apparent power',
  总交流功率因数: 'Total AC power factor',
  A相有功功率: 'A-phase active power',
  B相有功功率: 'B-phase active power',
  C相有功功率: 'C-phase active power',
  A相无功功率: 'A-phase reactive power',
  B相无功功率: 'Phase B reactive power',
  C相无功功率: 'C-phase reactive power',
  A相视在功率: 'A-phase apparent power',
  B相视在功率: 'Phase B apparent power',
  C相视在功率: 'Phase C apparent power',
  AB电压: 'AB voltage',
  BC电压: 'BC voltage',
  CA电压: 'CA voltage',
  AB电流: 'AB current',
  BC电流: 'BC current',
  CA电流: 'CA current',
  A相电压: 'A-phase voltage ',
  B相电压: 'B-phase voltage ',
  C相电压: 'C-phase voltage ',
  A相电流: 'A-phase current ',
  B相电流: 'B-phase current ',
  C相电流: 'C-phase current ',
  PCS模块温度: 'PCS module Temperature',
  PCS环境温度: 'PCS ambient temperature',
  PCS散热器温度: 'PCS radiator temperature',
  A1模块温度: 'A1 module Temperature',
  B1模块温度: 'B1 module Temperature',
  C1模块温度: 'C1 module Temperature',
  A2模块温度: 'A2 module Temperature',
  B2模块温度: 'B2 module Temperature',
  C2模块温度: 'C2 module Temperature',
  进风口温度: 'Air inlet temperature',
  出风口温度: 'Air outlet temperature',
  故障状态字: 'faultStatusWord',
  支路一: 'Branch one',
  支路: 'Branch',
  直流功率: 'DC power',
  直流电压: 'DC Voltage',
  直流电流: 'DC current',
  类别: 'Category',
  日正向总电能: 'Daily forward total electrical energy',
  日反向总电能: 'Daily total reverse energy',
  累计正向总电能: 'Accumulated total forward energy',
  累计反向总电能: 'Accumulated total reverse energy',

  堆状态: 'Stack  state',
  簇状态: 'Cluster state',
  禁充: 'Prohibit charging',
  禁放: 'Prohibit discharge',

  与PCS通信: 'Communicate with PCS',
  与EMS通信: 'Communicate with EMS',
  电池堆视图: 'Battery stack view',
  电池簇视图: 'Battery Cluster View',
  单体电池视图: 'Single Cell View',

  充放电状态: 'Charging and discharging status',
  空闲: 'Idle',
  总电压: 'Total voltage',
  总电流: 'Total current',
  充电限制功率: 'Charging limit power',
  放电限制功率: 'Discharge limiting power',
  可充电量: 'Rechargeable capacity',
  可放电量: 'Dischargeable capacity',
  平均温度: 'Average temperature',
  平均电压: 'Average voltage',
  绝缘值: 'Insulation value',
  正极绝缘值: 'Positive insulation value',
  负极绝缘值: 'Negative insulation value',
  最高温度: 'Maximum temperature',
  最低温度: 'Minimum temperature',
  最高电压: 'Max voltage',
  最低电压: 'Min voltage',
  电池组: 'Battery pack',

  电压: 'Voltage',
  电流: 'Current',
  接触器主正: 'Contactor main positive',
  接触器预充: 'Contactor pre charging',
  接触器总正: 'Positive contactor',
  接触器总负: 'Negative contactor',
  断开: 'Open',
  闭合: 'Closed',

  // 单位: '单位',
  最高: 'Max',
  最低: 'Min',
  均衡: 'Balancing',
  电池单体电压: 'Battery cell voltage',
  单体电压: 'Cell voltage',
  电池单体温度: 'Battery cell temperature',
  单体温度: 'Cell temperature',

  待机: 'Standby',
  系统状态: 'System state',
  关机: 'Power off',
  开机: 'Power on',
  湿度: 'Humidity',
  交流电压: 'AC voltage',
  出风温度: 'Air outlet temperature',
  回风温度: 'Return air temperature',
  冷凝温度: 'Condensation temperature',
  盘管温度: 'Coil temperature',
  柜外温度: 'Outside cabinet temperature',
  柜内温度: 'Cabinet temperature',
  柜内湿度: 'Humidity inside the cabinet',
  排气温度: 'Exhaust temperature',
  出风湿度: '出风湿度',
  融霜温度: 'Defrosting temperature',
  制热开启温度: 'Heating start temperature',
  制冷开启温度: 'Cooling start temperature',
  // 制热禁止温度: 'Heating prohibit temperature',
  // 制冷禁止温度: 'Cooling prohibit temperature',
  制热禁止温度: 'Heating off temperature',
  制冷禁止温度: 'Cooling off temperature',
  高温告警温度: 'High temperature alarm temperature',
  低温告警温度: 'Low temperature alarm temperature',
  高湿告警点: 'High humidity alarm point',
  // 高温告警点: '高温告警点',
  // 低温告警点: '低温告警点',
  // 报警时间: '报警时间',
  // 高低温告警: '高低温告警',
  // 高低压告警: '高低压告警',
  // 压缩机告警: '压缩机告警',
  // 传感器告警: '传感器告警',
  // 高低气压告警: '高低气压告警',
  排氢状态: 'Discharging hydrogen gas status',
  电加热: 'Electrical heating',
  压缩机: 'Compressor',
  应急风机: 'Emergency fan',
  室内风机: 'Indoor fan',
  室外风机: 'Outdoor fan',
  停止: 'Stop',
  一键空调启停: 'Air conditioning start stop',
  空调控制: 'Air-conditioning control',
  温度参数设置: 'Temperature parameter settings',
  请输入制冷启动温度: 'Please enter the cooling start temperature!',
  请输入制冷关闭温度: 'Please enter the cooling off temperature!',
  请输入制热启动温度: 'Please enter the heating start temperature!',
  请输入制热关闭温度: 'Please enter the heating off temperature!',
  请输入高温告警温度: 'Please enter the overtemperature alarm temperature!',
  请输入低温告警温度: 'Please enter the lower alarm temperature!',
  '制冷启动温度 - 制冷关闭温度 ≥ 1': 'Cooling start temperature - Cooling off temperature ≥ 1',
  '制热关闭温度- 制热启动温度 ≥ 1': 'Heating off temperature - Heating start temperature ≥ 1',
  请确认是否应用空调控制参数: 'Please confirm if the air conditioning control parameters are applied!',
  请确认是否应用空调温度参数: 'Please confirm if the air conditioning temperature parameter is applied!',
  '点击“确定”按钮前，请确认参数是否正确！': 'Before clicking the "OK" button, please confirm if the parameters are correct!',
  '部分空调控制能力互斥，无法同时开启！': 'Some air conditioning control capabilities are mutually exclusive and cannot be turned on simultaneously!',
  '点击“确定”按钮前，请确认参数是否正确！': 'Before clicking the "OK" button, please confirm if the parameters are correct!',
  加热启停: 'Heating start/stop',
  制冷启停: 'Refrigeration start/stop',
  待机启停: 'Standby start/stop',
  送风启停: 'Air supply start/stop',
  开1: 'On',
  关1: 'Off',
  开: 'On',
  关: 'Off',
  是否确认开启空调: 'Are you sure to turn on the air conditioning？',
  是否确认关闭空调: 'Are you sure to turn off the air conditioning?',
  空调参数配置: 'Air conditioning parameter configuration',
  '制冷启动温度数字范围 -100 - 100': 'Cooling start temperature number range -100 - 100',
  '制冷关闭温度数字范围 -100 - 100': 'Cooling off temperature number range -100 - 100',
  '制热启动温度数字范围 -100 - 100': 'Heating start temperature number range -100 - 100',
  '制热关闭温度数字范围 -100 - 100': 'Heating off temperature number range -100 - 100',
  '高温告警温度数字范围 -100 - 100': 'High temperature alarm temperature number range -100 - 100',
  '低温告警温度数字范围 -100 - 100': 'Low temperature alarm temperature number range -100 - 100',
  制冷启动温度: 'Cooling start temperature',
  制冷关闭温度: 'Cooling off temperature',
  制热启动温度: 'Heating start temperature',
  制热关闭温度: 'Heating off temperature',
  除湿开启温度: 'Dehumidification opening temperature',
  除湿关闭温度: 'Dehumidification closing temperature',
  除湿开启湿度: 'Dehumidification opening humidity',
  除湿关闭湿度: 'Dehumidification closing humidity',
  内风机转速: 'Internal fan speed',
  外风机转速: 'External fan speed',
  风扇: 'Fan',
  转速: 'Speed',
  风扇启停: ' Fan start/stop ',
  风扇参数配置: 'Fan parameter configuration',
  风扇启动温度: 'Fan start temperature',
  风扇关闭温度: 'Fan off temperature',

  tms液冷: 'TMS',
  TMS机组运行状态: 'TMS unit operating status',
  TMS运行模式: 'TMS operating mode',
  自动: 'Automatic',
  准备启动: 'Ready to start',
  tms运行: 'Run',
  tms延时停机: 'Delayed shutdown',
  tms故障: 'Failure',
  制冷: 'Refrigeration',
  加热: 'Heating',
  自循环: 'Self-looping',
  TMS供液温度: 'TMS supply temperature',
  TMS回液温度: 'TMS return temperature',
  TMS恒温方式预设温度: 'TMS constant temperature preset temperature',
  TMS供液压力: 'TMS supply pressure',
  TMS回液压力: 'TMS return pressure',
  环境温度: 'Environmental temperature',
  电芯温度: 'Cell temperature',
  电芯电压: 'Cell voltage',
  高压箱温度: 'HVB Temp',

  通信状态: 'Communication status',
  无通信: 'No communication',
  异常: 'Abnormal',
  CO浓度: 'CO concentration',
  氢气浓度: 'Hydrogen concentration',
  烟雾数值: 'Smoke value',
  VOC数值: 'VOC value',
  温度数值: 'Temperature value',
  CO浓度报警: 'CO concentration alarm',
  高温报警: 'High temperature alarm',
  温度报警: 'Temperature alarm',
  VOC报警: 'VOC alarm',
  烟雾报警: 'Smoke alarm',
  氢气浓度报警: 'Hydrogen concentration alarm',
  水浸报警: 'Water immersion alarm',
  是否确认开启消防: 'Are you sure to turn on fire protection?',
  是否确认关闭消防: 'Are you sure to turn off the fire protection?',

  报警等级: 'Alarm level',
  预留: 'Reserve',
  '1级报警': 'Level 1 alarm',
  '2级报警': 'Level 2 alarm',
  '3级报警': 'Level 3 alarm',
  '4级报警': 'Level 4 alarm',
  无故障: 'No fault',
  无通信: 'No communication',
  异常: 'Abnormal',
  消防: 'Fire fighting',

  消防开关控制: 'Fire switch control',
  故障码: 'Fault code',
  暂无: 'Not available',

  外设: 'Peripheral',
  急停状态: 'Scram condition',
  急停故障: 'Emergency stop fault',
  消防状态: 'Fire status',
  消防触发: 'Fire triggered',
  温感状态: 'Thermal state',
  温度异常: 'Abnormal temperature',
  门禁状态: 'Access control status',
  开启: 'Open',
  水浸状态: 'Flooded condition',
  水浸故障: 'Water immersion fault',
  烟感状态: 'Smoke sensing state',
  烟雾报警: 'Smoke alarm',

  高压分合闸状态: 'High voltage opening and closing status',
  合闸: 'Closing',
  分闸: 'Opening',
  远方就地状态: 'Remote local status',
  就地: 'Local',
  远方: 'Distant',
  高压: 'High voltage',
  高压IA: 'High voltage IA',
  高压IB: 'High voltage IB',
  高压IC: 'High voltage IC',
  高压3IO: 'High voltage 3IO',
  低压: 'Low voltage',
  低压UAN: 'Low voltage UAN',
  低压UBN: 'Low voltage UBN',
  低压UCN: 'Low voltage UCN',
  低压UAB: 'Low voltage UAB',
  低压IA: 'Low voltage IA',
  低压IB: 'Low voltage IB',
  低压UBC: 'Low voltage UBC',
  低压UCA: 'Low voltage UCA',
  低压IC: 'Low voltage IC',
  低压3IO: 'Low voltage 3IO',
  低压频率: 'Low voltage frequency',
  低压有功功率: 'Low voltage active power',
  低压无功功率: 'Low voltage reactive power',
  温度: 'Temperature ',
  油温: 'Oil temperature',
  低压功率因数: 'Low voltage power factor',
  告警图表: 'Alarm chart',
  告警列表: 'Alarm List',
  设备类型: 'Device type',
  告警等级: 'Warning level',
  监控: 'Monitoring',
  光伏逆变器: 'PV Inverter',
  // 传感器: '传感器',
  // IO控制器: 'IO控制器',
  电池簇: 'Battery Cluster',
  未分级: 'Ungraded',
  预警: 'Forewarning',
  告警: 'Give an alarm',
  起止时间: 'Beginning and ending time',
  开始时间: 'Start time',
  结束时间: 'Finish time ',
  设备名称: 'Device name',
  告警标题: 'Alarm title',
  客户告警: 'Customer alarm',
  故障发生时间: 'Time of failure',
  告警开始时间: 'Alarm start time',
  告警结束时间: 'Alarm end time',
  未修复: 'Wontfix',
  报警升级: 'Alarm escalation',
  报警降级: 'Alarm degradation',
  故障修复: 'Fault correcting',
  请选择站点: 'Please select a site!',
  处理建议: 'Treatment suggestion',
  无需处理: 'No handling required',
  运维处理: 'O&M handling',
  告警配置: 'Alarm configuration',
  请勾选可查看的处理建议类型: 'Select the solution types that can be viewed',

  电价配置: 'Electricity price allocation',
  模板管理: 'Template management',

  为对应月份选择模板后请点击绑定按钮以完成应用更换模板前请先点击解绑按钮才可重新选择:
    'After selecting the template for the month, click the "Bind" button to complete the application. Please click the "Unbind" button before replacing the template.',
  年份: 'Year',
  选择年份: 'Please select a year',
  请选择: 'Please select',
  绑定: 'Binding',
  当前: 'At present',
  解绑: 'Unbind',
  查看: 'Examine',
  模板详情: 'Template details',
  模板名称: 'Template name',
  模板状态: 'Template state',
  使用中: 'In use',
  未使用: 'Unused',
  使用情况: 'Use condition',
  模板标签: 'Template tag',
  开始时间: 'Start time',
  结束时间: 'Finish time ',
  时段: 'Time frame',
  买入电价元kWh: 'Purchase price (Yuan /kWh)',
  卖出电价元kWh: 'Selling price (Yuan /kWh)',
  是否确认解绑该模板: 'Do you want to unbind the template?',
  提示: 'Hint',
  确定电价: 'Confirm',
  点击引用模板按钮可将公共模板中的电价模板直接引用至当前页面下:
    'Click the "Reference Template" button to directly reference the electricity price template in the "Public template" to the current page！',
  请输入内容例如模版名称标签: 'Please enter the content, such as template name, label',
  引用模板: 'Reference template',
  创建模板: 'Create a template',
  标签: 'Label',
  创建人: 'Founder',
  创建时间: 'Creation time',
  操作: 'Operation',
  引用创建: 'Reference creation',
  编辑: 'Edit',
  删除: 'Delete',
  该模版正在使用中暂不支持删除请解绑后再操作: 'The template is in use, do not support deletion, please unbind after operation!',
  是否确认删除该模板: 'Do you want to delete the template?',
  模版编辑: 'Template editor',
  基础信息: 'Basic information',
  时段与电价: 'Time period and price',
  请输入模版名称: 'Please enter a template name',
  模版名称: 'Template name',
  标签名称: 'Label name',
  请输入标签名称: 'Please enter a label name',
  生成: 'Generate',
  标签名称以空格分隔完成后回车或点击生成按钮即可生成标签每个标签最多可输入20个字符最多支持生成10个标签:
    'Label names are separated by Spaces. Press enter or click the "Generate" button to generate labels. A maximum of 20 characters can be entered for each label, and a maximum of 10 labels can be generated.',
  标签管理: 'Label management',
  取消: 'Cancel',
  确定: 'Confirm',
  点击编辑后可以勾选标签后进行删除操作: 'After clicking "Edit", you can select the label and delete it',
  确定修改: 'Definite modification',
  下一步: 'next step',
  最多还可添加: 'Can I add at most',
  个标签: 'Tags',
  单个标签字符长度不可超过20: 'A single label contains a maximum of 20 characters',
  请选择要删除的标签: 'Select the label you want to remove',
  模板中时段与电价被修改后数据将同步到已绑定的月份中请谨慎操作:
    'After the time period and electricity price in the template are modified, the data will be synchronized to the bound month. Exercise caution when performing this operation.',
  时间编辑: 'Time editing',
  选择时间: 'Selection time',
  时段说明: 'Period specification',
  新增: 'Newly increased',
  电价编辑: 'Electricity price editing',
  确定添加: 'Definite addition',
  请选择开始时间: 'Please select a start time',
  开始时间不可与结束时间相同: 'The start time cannot be the same as the end time',
  选择结束时间: 'Please select a end time',
  请选择结束时间: 'Please select a end time',
  结束时间不可与开始时间相同: 'The end time cannot be the same as the start time',
  请选择时间段类型: 'Please select a time period type',
  请输入买入价格: 'Please enter the purchase price',
  请输入卖出价格: 'Please enter sell price',
  买入价格: 'Purchase price',
  卖出价格: 'Sell price',
  '买入价格数字范围 0 - 10000': 'Purchase price number range 0 - 10000',
  '卖出价格数字范围 0 - 10000': 'Sell price number range 0 - 10000',
  时间段存在冲突请重新配置: 'Time range conflict, please reconfigure!',
  选择需要引用的模板后点击确认按钮可将对应模板引用至模板管理中: 'Select the template you want to reference and click OK to reference the template to template management.',
  确定引用: 'Definitive reference',
  请选择引用模板: 'Please select a reference template',
  展开全部: 'Expand all',

  站点汇总展示所有站点报表数据支持按日展示31天按月展示一年内数据:
    'Site summary Displays the report data of all sites. The report data can be displayed on a daily basis for 31 days or on a monthly basis for one year.',
  站点汇总: 'Site summary',
  单站报表: 'Single station report',
  时间范围: 'Time frame',
  开始日期: 'Start date',
  结束日期: 'Finish date',
  开始月份: 'Starting month',
  结束月份: 'End month',
  开始年份: 'Starting year',
  结束年份: 'End year',
  报表导出: 'Report export',
  充电量kWh: 'Charge capacity(kWh)',
  放电量kWh: 'Discharge capacity(kWh)',
  按日: 'Daily',
  按月: 'Monthly',
  按年: 'Yearly ',
  请选择时间范围: 'Please select a time frame!',
  站点名称: 'Site name',
  报表类型: 'Report type',
  日报表: 'Daily statement',
  月报表: 'Monthly statement',
  年报表: 'Yearly statement',

  选择站点: 'Select site',
  充电价格元: 'Charging Price',
  放电价格元: 'Discharge price',
  充电价格: 'Charging Price',
  放电价格: 'Discharge price',
  // 元: 'Yuan',
  元: '',
  实际收益元: 'Actual income',
  总计: 'Total',

  系统数量: 'Number of systems',
  // 装机功率MW: '装机容量(MWh)',
  // 装机容量MWh: '装机容量MWh',
  修改: 'Modification',
  是否确认删除电站操作: 'Are you sure to delete the power station?',
  电站联系电话: 'Power station contact number',
  电站图片: 'Picture of the power station',
  修改电站: 'Modified power station',
  创建电站后需绑定系统: 'After creating the power station, it is necessary to bind the system',
  电站创建完成后需前往系统管理选择对应系统分配到电站后才可正常运行:
    'After the creation of the power station is completed, you need to go to the system management and select the corresponding system to be assigned to the power station before it can operate normally',
  更多信息: 'More information',
  请输入装机功率: 'Please enter the installed power',
  请输入装机容量: 'Please enter the installed capacity',
  装机功率数值范围大于0小于10000: 'The value greater than 0 and less than 10000',
  装机容量数值范围大于0小于10000: 'The value greater than 0 and less than 10000',
  '站点变压器容量数值范围1-9999整数': 'Transformer capacity Value range 1 to 9999 integer',
  请输入电站联系电话: 'Please enter the power station contact number',
  选择日期: 'Please select a date',
  国家: 'Country',
  省: 'Province',
  市: 'City',
  区: 'District',
  详细地址: 'Detailed address',
  电站经纬度: 'Station latitude and longitude',
  获取经纬度: 'Acquire latitude and longitude',
  经度: 'Longitude',
  纬度: 'Latitude',
  重新获取: 'Reacquire',
  点击上传: 'Click to upload',
  重新上传: 'Re-upload',
  创建: 'Establish',
  经纬度: 'Longitude&Latitude',
  请输入地区: 'Please enter a region',
  请输入电站名称: 'Please enter the name of the power station',
  请选择电站类型: 'Please select a power station type',
  未匹配到地点: 'No match to the location!',
  未找到搜索结果: 'No search results found!',
  格式有误图片大小不得超过5M支持PNGJPG格式: 'The format is incorrect. The image size cannot exceed 5M. PNG and JPG formats are supported.',
  上传的图片大小不得超过5M支持PNGJPG格式: 'The size of the image to be uploaded cannot exceed 5 MB. PNG and JPG formats are supported',

  电站业主: 'Power plant owner',
  请输入电站业主称呼: 'Please enter the name of the power plant owner',
  电站联系号码: 'Power Station Contact Number',
  请输入电站联系号码: 'Please enter the power station contact number',
  站点变压器容量: 'Station transformer capacity',
  请输入变压器容量: 'Please enter the transformer capacity',
  并网点信息: 'Consolidation point information',
  变压器信息: 'Transformer information',
  请输入变压器信息: 'Please enter transformer information',
  额度变压器容量: 'Rated transformer capacity',
  请输入额度变压器容量: 'Please enter the transformer capacity for the quota',

  安装人: 'Installer',
  请输入安装人称呼: 'Please enter the name of the installer',
  安装人联系号码: 'Installer Contact Number',
  请输入安装人联系号码: 'Please enter the contact number of the installer',
  安装图片: 'Equipment installation pictures',
  点击上传图片: 'Click to upload',
  上传的图片大小不得超过5M支持PNGJPG格式最多可上传5张图片: 'The size of uploaded images should not exceed 5M, supporting PNG and JPG formats, and up to 5 images can be uploaded',
  最多5张图片当前总数已超过请重新选择: 'Up to 5 images, the current total number has exceeded. Please reselect!',
  图片大小不可超过5M: 'Image size cannot exceed 5M',
  示例说明: 'Example description',
  '请按照示例上传图片以达到更佳展示效果。（建议使用横图，主体部分位于中央区域）':
    'Please follow the example to upload pictures to achieve a better display effect. (Horizontal map is recommended, with the main body in the central area)',
  有光伏: 'Photovoltaic',
  无光伏: 'No photovoltaics',
  有并网点: 'Parallel branch',
  无并网点: 'No branch',

  电价模版: 'Electricity price template',

  新增账号: 'Add an account',
  请输入内容例如姓名手机邮箱: 'Please enter the content, such as name, mobile phone, email',
  邮箱: 'Email',
  手机: 'Mobile phone',
  禁用: 'Forbidden',
  角色: 'Role',
  创建日期: 'Creation date',
  请确认是否禁用此账号: 'Please confirm whether to disable this account?',
  请确认是否恢复此账号: 'Please confirm whether to restore this account?',
  恢复: 'Recover',
  更多: 'More',
  查看账号: 'View account',
  重置密码: 'Reset passwords',
  密码重置: 'Reset the password',
  请确认是否删除此账号: 'Please confirm whether to delete this account?',
  站点分配: 'Site assignment',
  邮箱与手机至少填写一项用作为登录账号: 'Fill in at least one item of email and mobile phone as the login account',
  登录邮箱: 'Login email ',
  密码: 'Password',
  请勾选需要分配站点名称: 'Select the site name you want to assign',
  全部站点: 'All sites',
  所有站点包括未来新增站点: 'All sites (including future additions)',
  平台管理员默认管理所有站点包含未来新增站点不再支持站点自由分配:
    'The platform administrator manages all sites by default (including new sites in the future), and no longer supports free allocation of sites!',
  账号权限: 'Account authority',
  分配站点: 'Distribution site',
  新密码: 'New password',
  确认密码: 'Confirm password',
  六至二十位字符: '6-20 characters',
  请输入确认密码: 'Please enter your confirmation password',
  两次密码不一致请重新输入: 'The two passwords are inconsistent. Please re-enter them',
  请输入密码: 'Please enter your password',
  请输入名称: 'Please enter your name',
  请选择角色: 'Please select a role',
  请输入手机号码: 'Please enter your mobile number',
  请输入邮箱地址: 'Please enter your email address',
  编辑账号: 'Edit account',
  手机号邮箱不可同时为空: 'The email address and mobile phone number cannot be empty at the same time!',

  系统总览: 'System overview',
  批量添加: 'Bulk add',
  添加系统: 'Addition system',
  当需要添加的系统较多时可点击批量添加按钮批量添加请先: 'If a large number of systems need to be added, click the Batch Add button. (For batch addition, please ',
  下载Excel模板: 'download the Excel template',
  填写完成后再进行上传提交: ' first, fill it out and then upload and submit it)',
  请选择归属: 'Please select an affiliation',
  请输入内容例如EMS编号归属系统编号ICCID: 'Please enter content, such as EMS number, attribution, system number, ICCID',
  EMS编号: 'EMS number',
  归属状态: 'Attribution state',
  暂无归属: 'No attribution',
  未归属: 'No owner',
  电站: 'Power station',
  客户: 'Client',
  归属: 'Attribution',
  额定功率kW: 'Rated power(kW)',
  标称电压V: 'Nominal voltage(V)',
  冷却方式: 'Type of cooling',
  尺寸mm: 'Size(mm)',
  重量kg: 'Weight(kg)',
  是否确认删除系统操作: 'Are you sure to delete the system operation?',
  系统分配: 'System-assigned',
  是否确认撤回此次分配操作: 'Do you want to cancel this assignment?',
  系统撤回: 'Systematic withdrawal',
  请输入EMS编号: 'Please enter the EMS number',
  请输入系统编号: 'Please enter the system number',
  系统名称: 'System name',
  自定义系统编号名称: 'Custom system number name',
  规格参数: 'Specification parameter',
  请输入额定功率: 'Please enter the rated power',
  请输入额定容量: 'Please enter the rated capacity',
  请输入标称电压: 'Please enter the nominal voltage',

  请选择冷却方式: 'Please select a type of cooling',
  请输入尺寸长宽高: 'Please enter dimensions (L * W * H)',
  请输入重量: 'Please enter weight',
  查看系统: 'View system',
  额定功率: 'Rated power',
  额定容量: 'Rated capacity',
  标称电压: 'Nominal voltage',
  尺寸: 'Size',
  重量: 'Weight',
  额定功率数值范围大于0小于1000000: 'The value greater than 0 and less than 1000000',
  额定容量数值范围大于0小于1000000: 'The value greater than 0 and less than 1000000',
  标称电压数值范围大于0小于1000000: 'The value greater than 0 and less than 1000000',
  重量数值范围大于0小于1000000: 'The value greater than 0 and less than 1000000',

  选择电站名称: 'Please select the name of the power station',
  厂家: 'Manufacturers',
  输入厂家编码: 'Enter manufacturer code',
  文件上传完成后点击提交按钮以完成导入: 'Once the file is uploaded, click the Submit button to complete the import',
  文件大小: 'File size',
  上传日期: 'Upload date',
  拖拽到此区域: 'Drag to this area',
  请上传Excel文件文件大小在1M内: 'Please upload the Excel file, the file size is less than 1 MB',
  文件大小不符合规则请上传Excel文件文件大小在1M内: 'The file size does not meet the rules. Please upload the Excel file. The file size must be less than 1 MB',
  风冷: 'Air cooling ',
  液冷: 'Liquid cooling',
  其它: 'Others',
  无: 'No',
  修改系统: 'Modified system',
  请选择分配电站: 'Please select a distribution power station',
  系统已成功分配给: 'The system has been successfully assigned to the',
  请输入客户编码: 'Please enter client code',
  EMS系统批量导入模板: 'EMS system - Import templates in batches.xlsx',
  请上传格式内容正确文件: 'Please upload file with correct format content!',
  系统列表Excel已成功导入: 'The Excel system list has been imported successfully!',
  系统列表Excel导入失败请检查后重新尝试: 'System list Excel import failed, please check and try again!',
  请使用模板文件的格式进行上传上传文件只能是xlsxlsx格式: 'Please use the template file format to upload, upload files can only be xls, xlsx format!',
  请使用模板文件的格式进行上传上传文件大小不可超过1M: 'Please use the template file format to upload, the size of the uploaded file cannot exceed 1M!',
  系统信息为空请重新上传: 'System information is empty, please upload again!',
  EMS平台系统批量导入表格: 'EMS platform system - batch import form',
  EMS编号和系统编号不可为空: 'The EMS number and system number cannot be empty!',
  已成功导入: 'Successfully imported  ',
  条数据: ' pieces of data',
  失败1: 'failed  ',
  条1: '  pieces',
  请下载文件查看失败原因: 'Please download the file to see the reason for the failure！',

  登录: 'Login',
  账号: 'Account',
  密码: 'Password',
  请输入登录邮箱与密码: 'Please enter your login email and password',
  请输入账号: 'Please enter your account',
  记住密码: 'Remember the password',
  忘记密码: 'Forget the password',
  我已阅读并同意: 'I have read and agree to the ',
  隐私协议: 'Privacy Agreement',
  登录中: 'Loginning',
  还没有账号: 'Don＇t have an account yet?',
  立即注册: 'Register immediately',
  请确认已阅读并同意隐私协议: 'Please confirm that you have read and agree to the Privacy Agreement',
  账号注册完成正在审核中后续将有工作人员与您联系: 'The account registration is completed and is under review. A staff member will contact you later!',
  账号正在审核中后续将有工作人员与您联系: 'The account is under review, and a staff member will contact you later!',
  账号审核未通过请完善注册信息: 'Account audit did not pass, please improve the registration information',
  前往填写: 'Go and fill out',
  该账号目前没有权限访问: 'This account is currently not authorized to access',

  请输入注册邮箱账号和验证码来设置新密码: 'Please enter the registered email account and verification code to set a new password',
  请再次输入密码: 'Please enter your password again',
  验证码: 'Verification code',
  请输入验证码: 'Please enter the verification code',
  已发送: 'Be sent',
  发送中: 'Be sending',
  获取验证码: 'Get code',
  提交: 'Submit',
  返回登录: 'Back to login',
  发送成功: 'Send successfully',
  发送失败: 'Sending failure',

  注册: 'Register',
  注册信息补充: 'Registration information supplement',
  请按照流程依次填写等待账号审核: 'Please fill in according to the procedure and wait for the account review',
  企业名称: 'The name of firm',
  请输入企业名称: 'Please enter the business name',
  注册身份: 'Registered identity',
  请输入在企业中的职位: 'Please enter your position in the company',
  称呼: 'Salutation',
  请输入您的称呼: 'Please enter your name',
  手机号: 'Mobile number',
  请输入手机号: 'Please enter your mobile number',
  完成: 'Finish',

  工商业储能数据云平台: 'Industrial and commercial energy storage data cloud platform',
  智慧储能数据云平台: 'Intelligent storage data cloud platform',
  大屏总充电量: 'Total charge',
  大屏总放电量: 'Total discharge',
  大屏总充电: 'Total charge',
  大屏总放电: 'Total discharge',
  年2: 'years',
  年1: 'year',
  电量指标: 'Electric quantity index',
  电站指标: 'Power station index',
  收益排行: 'Revenue ranking',
  充放电趋势: 'Charge and discharge tendency',
  告警统计: 'Alarm statistics',
  电站总数个: 'Total number of power stations (units)',
  电站总数: 'Total number of power stations',
  总装机功率: 'Total installed power',
  总装机容量: 'Installed gross capacity',
  收益指标: 'Revenue target',
  累计收益万元: 'Cumulative income/K',
  '累计收益/元': 'Cumulative income',
  累计收益: 'Cumulative income',
  今日收益元: 'Today＇s revenue',
  收益趋势: 'Return trend',
  星期日: 'Sunday',
  星期一: 'Monday',
  星期二: 'Tuesday',
  星期三: 'Wednesday',
  星期四: 'Thursday',
  星期五: 'Friday',
  星期六: 'Saturday',
  weekday: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', '', 'Saturday'],
  单位次: '',
  万元: 'K',
  单位万元: 'Unit/ K',

  电量趋势: 'Energy trend',
  电站安全: 'Power station safety',
  安全运行时间天: 'Safe operating time (days)',
  安全运行时间: 'Safe operating time',
  天: 'days',
  按周: 'Weekly',
  排名: 'Ranking',
  社会公益: 'Social Welfare ',
  CO2减排吨: 'CO2 reduction (tons)',
  节约标准煤吨: 'Saving standard coal (tons)',
  等效植树量棵: 'Equivalent planting amount (tree)',
  周: 'Week',
  月: 'Month',
  返回: 'Return',

  EMS设备ID: 'EMS device ID',
  测试交流频率: 'Alternating current frequency',
  功率kW: 'Power/kW',
  有功功率: 'Active power',
  电池单体: 'Battery cell',
  并离网状态: 'And off-grid state',
  PCS通信状态: 'PCS communication status',
  EMS通信状态: 'EMS communication status',
  电池堆总电压: 'Total battery stack voltage',
  可充电量: 'Rechargeable capacity',
  可放电量: 'Dischargeable capacity',
  平均电压: 'Average voltage',
  电池堆总电流: 'Total current of the battery stack',
  累计充电量: 'Accumulated charge',
  累计放电量: 'Cumulative discharge',
  平均温度: 'Average temperature',
  电池簇数量: 'Number of cell clusters',
  循环次数: 'Number of cycles',
  单体最高温度: 'Maximum cell temperature',
  单体最高温度簇ID: 'Cell maximum temperature cluster ID',
  单体最高温度ID: 'ID of the highest temperature of a cell',
  单体最高温度组ID: 'ID of the monomer maximum temperature group',
  单体最低温度: 'Minimum cell temperature',
  单体最低温度簇ID: 'Minimum temperature cluster ID of a cell',
  单体最低温度ID: 'ID of the minimum temperature of a cell',
  单体最低温度组ID: 'Unit minimum temperature group ID',
  单体最高电压: 'Maximum cell voltage',
  单体最高电压簇ID: 'Maximum voltage cluster ID of a cell',
  单体最高电压ID: 'Maximum voltage ID of a cell',
  单体最高电压组ID: 'Maximum voltage group ID of a unit',
  单体最低电压: 'Minimum voltage of a unit',
  单体最低电压簇ID: 'Minimum voltage cluster ID of a cell',
  单体最低电压ID: 'Minimum voltage ID of a unit',
  单体最低电压组ID: 'Minimum voltage group ID of a unit',
  绝缘电阻: 'Insulation resistance',
  正极绝缘电阻: 'Positive insulation resistance',
  负极绝缘电阻: 'Negative insulation resistance',
  簇: 'Cluster',
  簇电压: 'Cluster voltage',
  簇电流: 'Cluster current',
  A相功率: 'A-phase power',
  B相功率: 'B-phase power',
  C相功率: 'C-phase power',
  主正接触器: 'Main positive contactor',
  主负接触器: 'Main negative contactor',
  电池簇电压: 'Battery cluster voltage',
  电池簇电流: 'Battery cluster current',
  电芯数量: 'Number of cells',
  温感数量: 'Temperature sensing quantity',
  电压差: 'Voltage difference',
  单体最小值: 'Monomer minimum',
  单体最小ID: 'Monomer minimum ID',
  单体最大值: 'Monomer maximum',
  单体最大ID: 'Monomer maximum ID',
  单体编号: 'Monomer number',
  月正向总电能: 'Monthly forward total electrical energy',
  月反向总电能: 'Month reverse total power',
  PCS工作状态: 'PCS working condition',
  实时有功功率: 'Real-time active power',
  实时无功功率: 'Real-time reactive power',
  今日数据图表: 'Today＇s data chart',
  总交流充电量: 'Total AC charge',
  总交流放电量: 'Total AC discharge',
  当天交流充电量: 'AC charging capacity of the day',
  当天交流放电量: 'AC discharge capacity of the day',
  交流总功率: 'Total ac power',
  手动功率: 'Manual power',
  AB交流线电压: 'AB AC line voltage',
  BC交流线电压: 'BC AC line voltage',
  CA交流线电压: 'CA AC line voltage',
  AB交流线电流: 'AB Current of the AC line',
  BC交流线电流: 'BC Current of the AC line',
  CA交流线电流: 'CA Current of the AC line',
  三相电流绝对值和: 'Absolute sum of three-phase current',
  三相电流和: 'Current sum of three phase',
  漏电流: 'Leakage Current',
  报警状态: 'Alarm state',
  报警时间: 'Alarm time',
  故障状态: 'Fault status',
  是: 'Yes',
  否: 'No',

  暂无数据: 'No data available',
  小于: 'Less than',
  小数点后: 'No more than',

  不允许超过: 'Digits are allowed after the decimal point',
  小数点后不允许超过1位: 'No more than 1 digits are allowed after the decimal point',
  小数点后不允许超过3位: 'No more than 3 digits are allowed after the decimal point',
  小数点后不允许超过9位: 'No more than 9 digits are allowed after the decimal point',

  值大于0: 'Value greater than 0',
  请输入合法数字: 'Please enter a legal number',
  // 请输入大于小于且小数点后不超过位的合法数字: '请输入大于小于且小数点后不超过位的合法数字',
  手机号码格式不正确: 'Mobile phone number format is incorrect!',
  邮箱格式不正确: 'The mailbox format is incorrect',
  请输入大于0数字: 'Please enter a number greater than 0',
  数字范围: 'Number range',
  整数: 'Integer',
  密码由620位字母或数字或字母数字特殊符号组成: 'Password consists of 6-20 letters or numbers or letters, numbers, special symbols',
  密码必须由6至20个字符组成支持字母不区分大小写数字和特殊符号: 'Passwords must consist of 6 to 20 characters and support letters (case insensitive), numbers, and special symbols.',
  登录已过期可以取消继续留在该页面或者重新登录: 'Login has expired, you can cancel to stay on the page, or log in again',
  '登录已过期，请重新登录': 'Login has expired, please login again!',
  重新登录: 'Log in again',
  该账号目前没有资源权限即将返回登录页: 'This account does not currently have access and will soon return to the login page...',
  该账号已退出登录或没有资源权限即将返回登录页: 'The account has logged out or has no resource rights and is about to return to the login page！',
  不超过200个字符: 'No more than 200 characters',

  待分配: 'To be distributed',
  新建工单: 'New construction work order',
  待接单: 'Pending order',
  处理中: 'In process',
  已处理: 'Processed',
  已完成: 'Completed',
  已关闭: 'Closed',
  工单编号: 'Work order number',
  工单类型: 'Order type',
  紧急程度: 'Degree of urgency',
  工单标题: 'Work order heading',
  安装工单: 'Installation work order',
  维修工单: 'Maintenance work order',
  紧急: 'Exigency',
  一般: 'Normal',
  分配工单: 'Distribution work order',
  处理人: 'Processor',
  关闭工单: 'Close work order',
  关闭原因: 'Shutdown reason',
  填写关闭原因: 'Fill in the closure reason',
  接单: 'Order taking',
  处理: 'handle',
  分配时间: 'Allocate time',
  接单时间: 'Order receiving time',
  处理结束时间: 'End of processing time',
  分配工单成功: 'The work order was assigned successfully.',
  关闭工单成功: 'Closing the work order succeeded.',
  编辑工单: 'Edit worksheet',
  接单成功: 'Order accepted successfully',
  您已成功接单: 'You have successfully accepted your order',
  工单内容可在处理中进行查看处理: 'The contents of the work order can be viewed and processed in processing',
  选择系统: 'Select system',
  处理方式: 'Processing mode',
  工单详情: 'Work order details',
  客户联系人: 'Customer contact',
  客户联系电话: 'Customer contact number',
  客户地址: 'Customer address',
  新建成功: 'Creation success',
  编辑成功: 'Edit success',
  请选择工单类型: 'Please select a work order type',
  请输入工单标题: 'Please enter the ticket title',
  处理结束: 'Processing completed',
  处理跟进: 'Follow-up processing',
  填写工单处理内容后点击确认即可结束处理此工单: 'Fill in the processing content of the work order and click "Confirm" to finish processing the work order.',
  填写内容后点击提交即可更新工单处理状态: 'Fill in the content and click Submit to update the work order processing status.',
  工单附件: 'Work order attachment',
  上传的附件只支持pdfdocdocxxlsxlsxtxt格式: 'The uploaded attachments only support pdf, doc, docx, xls, xlsx, txt',
  工单旅程: 'Ticket journey',
  处理描述: 'Process description',
  确认完成: 'Confirm',
  完成时间: 'Completion time',
  关闭时间: 'Closing time',
  分配: 'Distribution',
  点击上传附件: 'Upload attachment',
  确认工单: 'Confirmation work order',
  查看工单: 'View work order',
  请输入有效的手机号码: 'Please enter a valid mobile number',
  请输入处理描述: 'Please enter a processing description',
  处理结束成功: 'End of processing successful',
  处理跟进成功: 'Processing follow up success',
  最多5个附件当前总数已超过请重新选择: 'Maximum 5 attachments The current total number exceeds the limit. Please select another attachment.',
  禁止删除之前添加的图片文件: 'Delete previously added image files is prohibited',
  请输入工单编号标题内容: 'work order number / title / content...',
  文件大小不可超过10M: 'File size cannot exceed 10M',
  请选择处理人: 'Please select the handler',
  时段报表: 'Period report',
  时段数据: 'Period data',
  折线图: 'Line chart',
  柱状图: 'Bar chart ',
  表格: 'Form',
  当日数据: 'Data of the day',
  累计数据: 'Cumulative data',
  原始数据: 'Row data',
  系统: 'System - ',
  原始数据导出: 'Row data export',
  电量kWh: 'Electric/kWh',
  当日数据导出: 'Daily data export',
  累计数据导出: 'Cumulative data export',

  UPS开关控制: 'UPS switch control',
  放电测试: 'Discharge test',
  上机状态: 'Starting up',
  上电状态: 'Power on',
  待机状态: 'Standby',
  旁路状态: 'bypass',
  市电工作状态: 'Working status of mains power',
  电池供电状态: 'Battery powered',
  测试自检放电状态: 'Test self check discharge status',
  CONVERTER: 'CONVERTER',
  经济状态: 'Economic status',
  关机状态: 'Shutdown',
  保留: 'Retain',
  UPS类型: 'UPS type',
  UPS状态: 'UPS state',
  UPS运行状态: 'UPS running state',
  后备: 'Back-up',
  UPS温度: 'UPS temperature',
  电池维持时间: 'Battery maintenance time',
  输入: 'Input',
  R相电压: 'R phase voltage',
  R相电流: 'R phase current',
  总视在功率: 'Total apparent power',
  S相电压: 'S phase voltage',
  S相电流: 'S phase current',
  R相视在功率: 'R phase apparent power',
  T相电压: 'T phase voltage',
  T相电流: 'T phase current',
  S相视在功率: 'S phase apparent power',
  频率: 'Frequency',
  T相视在功率: 'T phase apparent power',
  输出: 'Output',
  直流电电池: 'Direct current (battery)',
  电池总压: 'Total battery voltage',
  电池温度: 'Battery temperature',
  容量: 'Capacity',
  额定信息: 'Rating Information',
  额定总功率: 'Total rated power',
  输入输出相数: 'Number of input and output phases',
  单进单出: 'Single in single out',
  三进单出: 'Three in one out',
  三进三出: 'Three in three out',

  额定输入电压种类: 'Type of rated input voltage',
  额定电池电压: 'Rated battery voltage',
  输出定额电压: 'Output rated voltage',
  输出定额电流: 'Output rated current',
  输出定额频率: 'Output rated frequency',
  额定电池节数: 'Rated number of cells',
  节: '',
  是否确认开启UPS: 'Confirm to start UPS',
  是否确认关闭UPS: 'Confirm to close UPS',
  是否开启放电测试: 'Discharge test on or off',
  分配至: 'Be assigned to',
  接单账号: 'Order receiving account number',
  工单标题必须少于50个字符: 'Content cannot exceed 50 characters',
  处理方式必须少于20个字符: 'Content cannot exceed 20 characters',
  客户名称必须少于20个字符: 'Content cannot exceed 20 characters',
  联系电话必须少于20个字符: 'Content cannot exceed 20 characters',
  客户联系人必须少于20个字符: 'Content cannot exceed 20 characters',
  处理描述必须少于100个字符: 'Content cannot exceed 100 characters',
  客户地址必须少于50个字符: 'Content cannot exceed 50 characters',
  工单详情必须少于200个字符: 'Content cannot exceed 200 characters',
  是否确认接单: 'Confirm receiving order or not',
  站点卡片: 'Station Card',
  全部省: 'All provinces',
  全部市: 'All the cities',
  全部区: 'All districts',
  编辑电站: 'Edit',

  上传图片: 'Upload Image',
  上传文件: 'Upload files',
  我知道了: 'I know',
  平台功能更新说明: 'Platform function update description',
  接收工单: 'Receipt of work order',
  处理进度更新: 'Processing progress updates',
  工单已确认处理完成: 'The work order has been confirmed to be processed',
  处理完成: 'Processing complete',
  全部国家: 'All countries',
  全部区域: 'All areas',
  除湿器: 'Dehumidifier',
  控温状态: 'Temperature control state',
  控湿状态: 'Humidity control state',
  除霜状态: 'Defrost State',
  高温告警: 'High temperature alarm',
  外部温度: 'outside temperature',
  内部温度: 'Internal temperature',
  控温方式: 'temperature control mode',
  降温: 'Cooling',
  升温: 'Warming',
  外部温度传感器故障状态: 'External temperature sensor fault status',
  内部温度传感器故障状态: 'Internal temperature sensor fault status',
  湿度传感器故障状态: 'Humidity sensor fault status',
  风机故障状态: 'Fan fault status',
  温度启动值: 'Temperature startup value',
  温度关闭值: 'Temperature shutdown value',
  除湿器启动值: 'Starting value of dehumidifier',
  除湿器关闭值: 'Dehumidifier shutdown value',
  除湿启动值: 'Dehumidification start-up value',
  除湿关闭值: 'Dehumidification shutdown value',
  运行中: 'In operation',
  未运行: 'Not running',
  控温手自动模式: 'Temperature control hand automatic mode',
  控湿手自动模式: 'Humidity control hand automatic mode',

  请输入站点名称搜索: 'Please enter the station name',
  请选择字段: 'Please select a field',

  数据分析: 'Data analysis',
  字段选择: 'Field selection',
  末次数据时间: 'Last data time',
  查询结果: 'Query results',
  打开: 'Open',
  请输入电站名称1: 'Enter the power station name',
  暂无搜索内容: 'No search content is available',
  ems通信状态: 'EMS communication status',
  日发电量: 'Daily power generation',
  总发电量: 'Total power generation',
  有功功率: 'Active Power',
  无功功率: 'Reactive Power',
  功率因数: 'Power Factor',
  正极电压: 'Positive voltage',
  负极电压: 'Negative voltage',
  R相电压: 'R phase voltage',
  S相电压: 'S phase voltage',
  T相电压: 'T phase voltage',
  R相电流: 'R phase current',
  S相电流: 'S phase current',
  T相电流: 'T phase current',
  RS线电压: 'RS line voltage',
  ST线电压: 'ST line voltage',
  TR线电压: 'TR line voltage',
  RS线电流: 'RS line current',
  ST线电流: 'ST line current',
  TR线电流: 'TR line current',
  R相温度: 'R phase temperature',
  S相温度: 'S phase temperature',
  T相温度: 'T phase temperature',
  散热器温度: 'heatsink temperature',
  电网频率: 'Grid frequency',
  消防反馈: 'Fire feedback',
  火灾报警: 'Fire alarm',
  消防故障: 'Fire fault',
  消防喷洒: 'Fire spray',
  喷洒: 'Spray',
  火灾状态: 'Fire status',
  火灾: 'Fire',
  消防设备: 'Fire equipment',
  急停: 'Scram',
  浸水: 'Flooded',
  故障1: 'Breakdown',

  请选择地区: 'Please select a region',
  搜索电站名称地址: 'Enter the power station name/address',

  进入电站: 'Enter',
  电站名称1: 'Station name',
  数量: 'Number',
  以下为: 'Fields searched:',
  的站点: '',

  充电桩: 'Charging station',
  操作日志: 'Operation Log',
  充电桩控制: 'Charging station control',
  操作内容: 'Operation content',
  操作账号: 'Operation account',
  请选择控制指令后点击确定以下发: 'Please select the control instruction and click "OK" to issue it!',
  控制指令: 'Control instructions',
  操作结果: 'Operation result',
  成功: 'Success',
  失败: 'Fail',
  运行1: 'Running',
  待机1: 'Stop',
  开机1: 'Enable',
  关机1: 'Disable',
  空调强控: 'Air conditioning strong control',
  TMS强控: 'TMS strong control',
  送风: 'Air supply',
  强控模式: 'Strong control mode',
  控制模式: 'Control mode',
  控制类别: 'Control class',
  自动模式: 'Automatic mode',
  强控模式下部分控制能力互斥无法同时开启: 'In strong control mode, some control capabilities are mutually exclusive and cannot be turned on at the same time!',
  如需解除强控指令请选择自动模式并应用以恢复到自动运行状态:
    'If you need to cancel the strong control command, please select the automatic mode and apply it to restore to the automatic operation state',
  清除强控指令并执行设备自动模式: 'Clear the strong control command and execute the device automatic mode',
  请选择控制模式: 'Please select control mode!',
  请选择控制类别: 'Please select a control class!',
  本地控制: 'Local control',
  调试方式: 'Debug mode',
  指EMS禁止本地控制: 'Local control is prohibited by the EMS.',
  指EMS禁止远程控制: 'Remote control is prohibited by the EMS.',
  仅支持在本地屏进行控制模式变更: 'You can change the control mode only on the "Local screen".',
  时间范围只能选择17天: 'The time range can only be selected from 1-7 days',
  未选配: 'Not selected',

  市电状态: 'Mains power status',
  电池电压状态: 'Battery voltage status',
  不正常: 'Abnormal',
  低: 'Low',
  电池电压低: 'Low battery voltage',
  转换器: 'Converter',

  环境监测: 'Environmental monitoring',
  环境湿度: 'Environmental humidity',

  批量操作: 'Batch operation',
  批量分配: 'Batch allocation',
  当前已选: 'Currently selected',
  项: '',
  系统批量分配: 'System batch allocation',

  设备数据: 'Equipment data',
  设备故障字: 'Equipment fault word',
  支路数据: 'Branch data',
  电量数据: 'Electricity data',

  故障复位: 'Fault reset',
  确认提示: 'Confirmation tips',
  请确认是否下发故障复位指令该指令每30秒内只可下发一次: 'Please confirm whether to issue the fault reset instruction, this instruction can only be issued once every 30 seconds!',
  请确认是否下发设备复位指令: 'Please confirm whether to issue the device reset instruction!',
  工作模式: 'Mode of work',
  除湿: 'Dehumidification',
  制热: 'Heating up',
  并网: 'On grid',
  离网: 'Off grid',
  自检: 'Self check',
  组: 'Group',
  单体: 'Monomer',
  单体电池: 'Single cell battery',
  错误码: 'Error code',
  BMS并网控制: 'BMS grid connection control',
  一键并网控制: 'One-button grid connection control',
  请确认是否下发当前控制指令: 'Please confirm whether the current control command is sent?',
  全部堆: ' All stacks',
  控制对象: 'Controlled member',
  请选择控制对象和控制指令: 'Please select control object and control command',
  请选择控制对象: 'Please select the control object',
  请选择控制指令: 'Please select a control command',
  // 自检: 'Self check',
  货币单位: 'Monetary unit',

  电价表: 'Electrovalence meter',
  解除同步: 'Unsynchronize',
  列表: 'List',
  趋势: 'Trend',
  国家: 'Country',
  地区: 'Region',
  起始日期: 'Start date',
  电价: 'Electrovalence',
  动态电价: 'Dynamic electricity price',
  同步电价: 'Synchronous tariff',
  请选择地区时区和起始时间后点击同步电价按钮平台将自动把对应电价数据与站点电价表同步:
    'After selecting the region, time zone and start time, click the button of synchronous electricity price, and the platform will automatically synchronize the corresponding electricity price data with the site electricity price meter.',
  请确认是否将以下电价数据与电站同步: 'Please confirm whether the following electricity price data will be synchronized with the power station?',
  起始日: 'Start date',
  能量控制参数由平台根据智慧能量管理算法生成请确保系统额定容量与额定功率数值真实准确:
    'The energy control parameters are generated by the platform according to the intelligent energy management algorithm. Please ensure that the values of "rated capacity" and "rated power" of the system are true and accurate.',
  智慧控制: 'Intelligent control',
  人工控制: 'Manual control',
  手动能量控制: 'Manual energy control',
  时区: 'Time zone',
  额定容量: 'Rated capacity',
  启用: 'Enable',
  智慧策略: 'Intelligent strategy',
  当前策略: 'Current strategy',
  历史策略: 'Historical strategy',
  人工: 'artificial',
  通过智慧算法生成: 'Generated by smart algorithms',
  当前暂无策略: 'There is currently no strategy',
  请确认是否启用智慧控制启用后将会停止人工控制策略进入待机状态直到新的智慧控制策略下发:
    'Please confirm whether the smart control is enabled or not. After it is enabled, the manual control strategy will be stopped and the standby state will be entered until the new smart control strategy is issued!',
  请确认是否启用人工控制启用后智慧控制策略将会被停用: 'Please confirm whether to enable manual control, the smart control strategy will be deactivated!',
  数据来源: 'Data sources',
  计划SOC: 'Planned SOC',
  请输入计划SOC: 'Please input SOC',
  已同步至: 'Synchronized to',
  '请确认是否修改当前电价，修改后仅保留上传修改数据！': 'Please confirm whether to modify the current electricity price, and only upload the modified data after modification!',
  '电价数值范围 1-9999 整数': 'Electricity price Value range 1 to 9999 integer',
  暂未配置电价请点击同步电价: 'Electricity price has not been configured, please click Sync electricity price',
  当前同步电价未绑定到达同步日期后将停止更新电价信息请及时配置电价以免影响电站收益统计:
    'The current synchronous electricity price is not bound, and will stop updating the electricity price information after reaching the synchronization date. Please configure the electricity price in time to avoid affecting the revenue statistics of the power station!',
  暂未获取到当日电价: 'The electricity price of the day has not been obtained',
  请确认是否解除同步解除同步后将停止获取新的电价信息: 'Please confirm whether the synchronization is unsynchronized, after the synchronization will stop getting new electricity price information!',
  计划SOC: 'Planned SOC',
  请输入计划SOC: 'Please input SOC',
  DCDC设备故障字: 'DCDC equipment fault status word',
  DCDC故障状态字: 'DCDC fault status word',
  重置统计: 'Reset Statistics',
  此操作将清除当前站点下全部系统的告警历史及统计数据是否确认清除: 'This operation will clear the alarm history and statistical data of all stations under the current site. Are you sure to clear it?',
  此操作将清除当前系统下全部系统的告警历史及统计数据是否确认清除: 'This operation will clear the alarm history and statistical data of all systems under the current system. Are you sure to clear it?',
  重置站点告警: 'Reset station warning',
  重置系统告警: 'Reset system warning',
  重置成功: 'Reset successful',
  是否删除此告警: 'Do you want to delete this alarm?',
  结束: 'End',
  结束告警: 'End alarm',
  时区: 'Time zone',
  结束时间不能小于开始时间: 'The end time cannot be earlier than the start time.',
  运维处理今日: 'O&M processing(Today)',
  表示当前站点系统的设备告警状态告警内容为运维处理内容: 'Indicates the device alarm status of the current site system. The alarm content is O&M processing content.',
  当前的告警内容为运维处理内容: 'The current alarm content is O&M processing content.',
  光伏开关控制: 'Photovoltaic switching control',
  是否确认开启光伏逆变器: 'Do you want to start the PV inverter?',
  是否确认关闭光伏逆变器: 'Do you want to turn off the PV inverter?',
  设备复位: 'Device reset',
  光伏强控: 'Photovoltaic strong control',
  电流互感器变比: 'Current transformer ratio',
  电压互感器变比: 'Potential transformer ratio',
  累计正向总电能原始值: 'Accumulated total forward energy（Original value）',
  累计反向总电能原始值: 'Accumulated total reverse energy（Original value）',
  请输入系统名称搜索: 'Please enter the system name',

  控制配置: 'Control configuration',
  引用配置: 'Reference configuration',
  SOC参数设置: 'SOC parameter setting',
  PCS启停: 'PCS start-stop',
  PCS模式控制: 'PCS mode control',
  PCS并离网控制: 'PCS and off-grid control',
  BMS二级保护: 'BMS Secondary protection',
  空调启停: 'Air conditioner start-stop',
  空调工作模式设置: 'Air conditioner working mode',
  空调参数设置: 'Air conditioner parameter setting',
  TMS工作模式设置: 'TMS working mode setting',
  消防启停: 'Fire start-stop',
  UPS启停: 'UPS start-stop',
  充电桩启停: 'Charging pile start-stop',
  柴发启停: 'Diesel generator start-stop',
  柴发: 'Diesel generator',
  BMS并离网: 'BMS and off-grid',
  光伏启停: 'Pv start-stop',
  光伏复位: 'Photovoltaic reset',
  DCDC启停控制: 'DCDC start and stop control',
  DCDC故障复位控制: 'DCDC fault reset control',
  确认: 'Confirm',
  默认开启能量管理下的手动能量控制防过载防逆流功能可选中或取消控制配置点击确认以下发:
    'By default, the functions of manual energy control, anti-overload, and anti-countercurrent under energy management are enabled. You can select or cancel the control configuration, and click OK to deliver!',
  请选择要引用配置的系统引用后将会覆盖当前内容: 'Please select the system you want to reference the configuration, after the reference will overwrite the current content!',
  系统绑定: 'System binding',
  主从配置: 'Master-slave configuration',
  请确认是否绑定该系统到当前站点: 'Please confirm whether to bind the system to the current site!',
  主从模式: 'Master/Slave mode',
  输入编号: 'Enter the number',
  主机: 'Master',
  从机: 'Slave',
  未知: 'Unknown',
  主机数量必须为1: 'The number of hosts must be 1',
  禁止输入重复编号: 'Prohibit entering duplicate numbers!',
  系统控制: 'System control',
  设备控制: 'Equipment control',
  关联设备: 'Associated devices',
  已选系统: 'Selected system',
  当前主从配置只针对平台展示并不会更改实际主从模式配置: 'The current master-slave configuration is only for platform display and will not change the actual master-slave mode configuration.',
  部分编号未添加: 'Some of the numbers have not been added.',
  是否确认解绑: 'Are you sure to unbind?',
  暂无系统可点击系统绑定进行添加: 'There is currently no system available, you can click on the system binding to add it',
  请输入系统编号系统名称ems编号: 'System number/system name/ems number',
  过载保护: 'Overload protection',
  主从编号: 'Master/slave number',
  暂未选择系统: 'No system has been selected yet',
  暂不支持输入0: ' 0 input is not supported!',
  共: 'Total：',
  项数据: '',
  DCDC强控: 'DCDC strong control',
  输入端电压: 'Input voltage',
  恒流充放电: 'CC charging',
  恒压充放电: 'CV charging',
  恒功率充放电: 'CP charging',
  高压侧恒压: 'CHV',
  输入端电流: 'Input current',
  输出端电压: 'Output voltage',
  输出端电流: 'Output current',
  输入端功率: 'Input power',
  输出端功率: 'Output power',
  机内温度: 'Internal temperature',
  视在功率: 'Apparent power',
  触发: 'Trigger',
  声光报警器: 'Audible and visual alarm',
  PCS触发信号: 'PCS trigger signal',
  门禁灯: 'Access control light',
  断路器驱动: 'Circuit breaker drive',
  空调干节点: 'Air conditioning dry node',
  消防干节点: 'Fire dry node',
  风扇继电器: 'Fan relay',
  显示屏控制: 'Display screen control',
  充电桩控制: 'Charging station control',
  设备录入: 'Equipment input',
  引用配置: 'Reference configuration',
  请选择要引用配置的系统引用后将会覆盖当前配置内容: 'Please select the system you want to reference the configuration, the reference will overwrite the current configuration content!',
  可选中设备后输入设备数量点击确认新增设备: 'After selecting the device, input the number of the device and click Confirm to add the device.',
  选择系统: 'Selection system',
  新增设备: 'New equipment added',
  储能电表: 'Energy storage meter',
  电网连接点电表_低压侧: 'Grid meter/Low side',
  电网连接点电表_高压侧: 'Grid meter/High side',
  负载电表: 'Load meter',
  储能监测电表: 'Energy storage monitoring meter',
  光伏电表: 'Photovoltaic meter',
  请确认是否取消当前设备录入配置退出页面后录入信息不会保存需重新录入:
    'Please confirm whether to cancel the current device entry configuration. The input information will not be saved after exiting the page and needs to be re-entered！',
  请确认是否保存当前设备录入信息: 'Please confirm whether to save the current device input information!',
  选择系统: 'Select system',
  若填写电池堆数量电池堆下至少电池簇数量填1不能为空:
    'If the number of battery stack is filled in, at least the number of battery clusters under the battery stack is filled in 1, and it cannot be empty!',
  字母数字下划线组成: 'Alphanumeric characters are underlined',
  设备ID长度为150: 'The device ID length is 1-50',
  输入的数量必须是整型数值: 'The quantity entered must be an integer value',
  只能输入数值: 'Numeric input only',
  设备序号或者设备Id不能重复: 'Device serial numbers or device ids cannot be duplicated',
  信息不能为空: 'The information cannot be null',
  设备录入成功: 'The device was entered successfully!',
  设备ID: 'Device ID',
  型号: 'Model number',
  断路器: 'circuitBreaker',
  pcs状态信号: 'pcsStatusSignal',
  柜体风机反馈: 'cabinetFanFeedback',
  添加设备后请填写设备信息其中序号和设备ID为必填项厂家和型号为非必填项:
    'Please fill in the equipment information after adding the equipment, where the serial number and equipment ID are required, and the manufacturer and model are not required.',
  是否确认删除当前设备: 'Whether to confirm deleting the current device?',
  是否要删除当前选择的设备: 'Whether the currently selected device should be deleted?',
  调速器: 'Governor',
  柴发: 'Diesel generator',
  综合保护设备: 'Comprehensive protection equipment',
  待运维处理: 'Waiting O&M handling',
  待运维: 'waiting O&M',
  发生中告警: 'Alarm in progress',
  无需关注: 'No need to care',
  初始化: 'Initialize',
  等待: 'Wait',
  烧录: 'Burn',
  机组断路器状态: 'Gen breaker status',
  市电断路器状态: 'Mains breaker status',
  发动机油压: 'Oil pressure',
  发动机水温: 'Coolant temperature',
  发动机燃油油位: 'Fule level',
  充电发电机电压: 'Charge alternator voltage',
  蓄电池电压: 'Engine Battery voltage',
  发动机转速: 'Engine speed ',
  发动机运行时间: 'Engine run time',
  启动次数: 'Number of starts',
  柴发控制: 'Diesel generator control',
  机组状态: 'Gen status',
  秒: 'Second',
  报警: 'Alarm',
  有效: 'Valid',
  无效: 'Invalid',
  测试: 'Test',
  engine工作状态: 'Engine working status',
  发电机总有功功率: 'Engine total active power',
  发电机总无功功率: 'Engine total reactive power',
  发电机总视在功率: 'Engine total apparent power',
  合闸: 'Closing',
  分闸: 'Opening',
  辅电信号: 'Auxiliary signal',

  待运维处理: 'Waiting O&M handling',
  待运维: 'Waiting O&M',
  重要: 'Important',
  严重: 'Serious',
  未分级: 'Ungraded',
  告警中心: 'Alarm Center',
  告警监控: 'Alarm monitoring',
  告警电站: 'Alarm power station',
  告警总览: 'Alarm Overview',
  待运维处理电站: 'Waiting O&M processing station',
  告警中电站: 'Power station under alarm',
  待运维处理告警: 'Waiting O&M processing alarm',
  发生中告警: 'During alarm',
  电站筛选: 'Power plant screening',
  全部电站: 'All power stations',
  无需关注电站: 'No need to pay attention to the power station',
  待运维电站: 'Waiting O&M station',
  告警详情: 'Alarm details',
  告警总数: 'Total number of alarms',
  待运维告警: 'Waiting O&M alarm',
  无需关注告警: 'No need to pay attention to alarms',
  等级: 'Grade',
  类型: 'Type',
  详情: 'Details',
  电站系统: 'Power plant system',
  运维告警详情: 'O&M alarm details',
  全选: 'Select All',
  设备: 'Device',
  业务: 'Business',
  通讯: 'Communication',
  告警类型: 'Alarm type',
  已结束告警记录只保留近7日更多告警信息请前往右上角告警历史查看:
    'The finished alarm record is only kept for nearly 7 days. For more alarm information, please go to "alarm History" in the upper right corner.',
  '此操作前提是必须先选择指定站点系统！': 'The premise of this operation is to select the specified site system first!',
  站点告警: 'Site alarm',
  电站告警详情: 'Power plant alarm details',
  历史告警: 'Historical alarms',
  告警筛选: 'Alarm filtering',
  通讯: 'communication',
  复制成功: 'Copy success',
  事故总信号: 'Accident overall signal',
  过流I段跳闸: 'Overcurrent section I trip',
  过流II段跳闸: 'Overcurrent section II trip',
  过流III段跳闸: 'Overcurrent section III trip',
  过流I段压板: 'Overcurrent section I pressure plate',
  过流II段压板: 'Overcurrent section II pressure plate',
  过流III段压板: 'Overcurrent section III pressure plate',
  出水温度: 'Water outlet temperature',
  进水温度: 'Inlet water temperature',
  水泵状态: 'Pump status',
  补水泵运行状态: 'Make up pump status',
  外风机状态: 'FanStatus',
  吸气温度: 'Suction temp',
  板换温度: 'Plate temp',
  冷凝盘管温度: 'Condensing temp',
  进出水压差值: 'Water pressure difference',
  高压侧压力值: 'High pressure',
  低压侧压力值: 'Low pressure',
  电子膨胀阀开度: 'Electronic expansion valve',
  交流供电电压: 'Ac power voltage',
  压缩机转速: 'Compressor speed',
  累计充电电量: 'Cumulative charge capacity',
  充电电压: 'Voltage of charge',
  充电电流: 'Current of charge',
  充电功率: 'Power of charge',
  充电请求功率: 'Charge request power',
  最大允许充电功率: 'Maximum allowed charging power',
  充电枪已连接: 'Charging gun connected',
  充电结束: 'End of charge',
  防逆流功能禁能中如需操作请使能: 'The anti backflow function is disabled. If you need to operate it, please enable it!',
  防过载功能禁能中如需操作请使能: 'The anti overload function is disabled. If you need to operate it, please enable it!',
  禁用时段设置: 'Disable time period settings',
  用于设置防逆流功能禁能时段通过开关控制功能是否启用每次调整后需点击应用按钮方可生效:
    'Used to set the disabling period of the anti backflow function, which is controlled by a switch to enable the function. After each adjustment, the "Apply" button needs to be clicked to take effect',
  控制开关: 'Control switch',
  禁能时段: 'Prohibition period',
  重新启用: 'Re enable',
  是否确定重新启用: 'Are you sure you want to reactivate it?',
  系统2: 'System',
  统计配置: 'Statistical allocation',
  重新选择: 'Reselect',
  时区偏移量: 'Time zone offset',
  基本信息: 'Basic information',
  统计状态: 'Statistical state',
  已开启: 'Open',
  统计开始时间: 'Statistics start time',
  最多支持查看7日范围的数据: 'Up to 7 days of data are supported',
  '请重新选择统计开始时间（建议选择充放电量都为0的时间点）': 'Please reselect the start time of statistics (it is recommended to select the time point when the charge and discharge are 0)',
  '开启统计配置时，建议选择充放电量都为0的时间点，请先确认EMS本地能耗计已清零！':
    'When starting the statistical configuration, it is recommended to select the time point when the charge and discharge amounts are 0. Please first confirm that the EMS local energy consumption meter has been cleared!',
  '开启统计配置时，请先确认EMS本地能耗计已清零！': 'Please confirm that the EMS local energy meter has been cleared before starting the statistical configuration!',

  '当前统计未开启，请先选择统计开始时间（建议选择充放电量都为0的时间点）':
    'The current statistics is not open, please select the start time of statistics first (it is recommended to select the time point when the charge and discharge amount are 0).',
  '请确认是否开启统计？': 'Please confirm whether statistics is enabled?',
  '开启统计后，平台将按照设置的“统计开始时间”进行统计！': 'After statistics are enabled, the platform will make statistics according to the set "statistics start time"！',
  '请确认是否变更统计开始时间？': 'Please confirm whether to change the start time of statistics?',
  '变更后，平台将按照新设置的时间进行重新统计！': 'After the change, the platform will re-count according to the new set time!',
  上次选择时间: 'Time of last selection',
  '开启统计时间失败!': 'Failed to enable time statistics!',
  选择日期时间: 'Selecting a date and time',
  请选择统计开始时间: 'Please select the start time of statistics',
  统计开始时间未变更: 'The statistics start time has not changed',
  软件复位: 'Software reset',
  请确认是否下发软件复位指令: 'Please confirm whether to issue a software reset command',
  '能量控制-导入表格.xlsx': 'Energy controller-import of forms.xlsx',
  '请确认是否导入Excel,导入后将覆盖当前内容！': 'Please confirm whether to import Excel, the current content will be overwritten after import!',
  '设置参数后，需点击“应用”按钮方可执行。无充电或放电操作的时间段，将执行待机操作!（支持':
    'After setting the parameters, you need to click the "Apply" button to execute. When there is no charging or discharging operation, standby operation will be performed! (Support',
  下载Excel模板: 'Download Excel templates',
  ',填写完成后再进行Excel导入，导入成功后需点击应用以执行）': '. Excel import will be carried out after completion. After successful import, click Apply to execute)',
  Excel导入: 'Excel Import',
  导入成功: 'Import successfully',
  '导入失败!': 'Import failed!',
  '请确认后点击应用执行！': 'Please confirm and click Apply to execute!',
  EMS通讯: 'EMS communication',
  常用电源状态: 'Common power conn state',
  备用电源状态: 'Standby power conn state',
  '常用电源 A 相电压': 'A phase voltage of common power supply',
  '常用电源 B 相电压': 'B phase voltage of common power supply',
  '常用电源 C 相电压 V': 'C phase voltage of common power supply',
  常用电源频率: 'Common power supply frequency',
  '备用电源 A 相电压': 'Standby power supply phase A voltage',
  '备用电源 B 相电压': 'Standby power supply phase B voltage',
  '备用电源 C 相电压': 'Standby power supply phase C voltage',
  备用电源频率: 'Standby power frequency',

  制冷目标温度: 'Target cooling temperature',
  制热目标温度: 'Target temperature for heating',
  自循环温度: 'Self circulation temperature',
  请输入制冷开启温度: 'Please enter the cooling opening temperature!',
  '制冷开启温度数值范围 -100 - 100整数': 'Cooling opening temperature value  range -100 -100 integer',
  '制冷关闭温度数值范围 -100 - 100整数': 'Cooling off temperature value  range -100 -100 integer',
  请输入制热开启温度: 'Please enter the heating opening temperature!',
  '制热开启温度数值范围 -100 - 100整数': 'Heating opening temperature value  range -100 -100 integer',
  '制热关闭温度数值范围 -100 - 100整数': 'Heating off temperature value  range -100 -100 integer',
  请输入制冷目标温度: 'Please enter the refrigeration target temperature!',
  '制冷目标温度数值范围 -100 - 100整数': 'Refrigeration target temperature value range -100 -100 integer',
  请输入制热目标温度: 'Please enter the heating target temperature!',
  '制热目标温度数值范围 -100 - 100整数': 'Heating target temperature value range -100 -100 integer',
  请输入自循环温度: 'Please enter the self-circulation temperature!',
  '自循环温度数值范围 -100 - 100整数': 'Self-circulation temperature value range -100 -100 integer',
  请确认是否应用TMS温度参数: 'Please confirm whether TMS temperature parameter is applied?',
  '制冷开启温度 - 制冷关闭温度 ≥ 1': 'Cooling opening temperature - Cooling off temperature ≥ 1',
  '制热关闭温度- 制热开启温度 ≥ 1': 'Heating off temperature - Heating opening temperature ≥ 1',
  TMS参数设置: 'TMS parameter setting',
  制冷温度需要均大于制热温度: 'The refrigeration temperature needs to be greater than the heating temperature',
  '请填写制冷开启温度 > 制冷关闭温度': 'Please fill in cooling on temperature > cooling off temperature!',
  '请填写制热关闭温度 > 制热开启温度': 'Please fill in heating off temperature > Heating on temperature!',
  直流脱扣: 'Direct current trip',
  交流脱扣: 'Alternating current trip',
  BMS控制: 'BMS control',
  'BMS 控制': 'BMS control',
  BMS脱扣控制: 'BMS trip control',
  BMS软件复位: 'BMS Software reset',
  '请确认是否下发该指令，指令每30秒内可下发一次！': 'Please confirm whether to send the command, the command can be sent every 30 seconds!',
  用户类型: 'User type',
  管理员: 'Administrator',
  普通用户: 'Domestic consumer',
  到期类型: 'Maturity type',
  永久: 'Permanent',
  自定义时间: 'Custom time',
  到期时间: 'Maturity time',
  '7天': '7 days',
  '15天': '15 days',
  '30天': '30 days',
  '6个月': '6 months',
  '1年': '1 year',
  请选择到期时间: 'Please select expiration time!',
  个人信息: 'Personal information',
  账号名称: 'Account name',
  账号邮箱: 'Account email',
  账号手机: 'Account phone',
  账号角色: 'Account role'
}
